import React, {PropTypes} from 'react';
import FeeListActiveContainer from './FeeListActiveContainer.jsx';
import FeeListInactiveContainer from './FeeListInactiveContainer.jsx';
import DeactivateModalContainer from './DeactivateModalContainer.jsx';

const Fees = ({
  inactiveFeesQty,
  activeFeesQty,
  onNewFeeClick
}) => (
  <div className="flex center animated fadeIn">
    <div className="col-xs-12 col-lg-10">
      <div className="flex space-between vertical-center">
        <h2>{`Active Fees`} <small>{`(${activeFeesQty})`}</small></h2>
        <div className="text-right">
          <button
            type="button"
            className="btn btn-primary btn-lg"
            onClick={onNewFeeClick}
          ><i className="fa fa-plus" /> {`New Fee`}</button>
        </div>
      </div>
      {
        activeFeesQty
        ? <FeeListActiveContainer />
      : <div className="alert alert-info">{`No information to display.`}</div>
      }
      {
        inactiveFeesQty
        ? <div>
            <br />
            <h2>{`Inactive Fees`} <small>{`(${inactiveFeesQty})`}</small></h2>
            <FeeListInactiveContainer />
          </div>
        : null
      }
    </div>
    <DeactivateModalContainer />
  </div>
);

Fees.propTypes = {
  inactiveFeesQty: PropTypes.number,
  activeFeesQty: PropTypes.number,
  onNewFeeClick: PropTypes.func
};

export default Fees;



// WEBPACK FOOTER //
// ./src/features/tournament/fees/Fees.jsx